import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
i18n
  .use(HttpApi) // Carregar traduções dinamicamente
  .use(LanguageDetector) // Detecta o idioma do navegador
  .use(initReactI18next) // Integração com React
  .init({
    fallbackLng: "pt-br", // Idioma padrão caso não detecte
    debug: false, // Ativar logs no console para depuração
    interpolation: {
      escapeValue: false, // Evita problemas com XSS em React
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // Caminho para os arquivos de tradução
    },
  });
export default i18n;
